/* eslint-disable */
import React, { useEffect } from 'react';
import CreateLecture from './CreateLecture';

const SectionCreateOrUpdate = ({
    moduleType,
    register,
    section,
    getValues,
    setValue,
    errors,
    createSectionHandler,
    updateSectionNameHandler,
    setBgBlurModal
}) => {
    useEffect(() => {
        if (moduleType === 'update') {
            setValue('sectionName', section?.sectionName);
        } else {
            setValue('sectionName', '');
        }
    }, [moduleType, setValue, section?.sectionName])

    return (
        <div className='p-2 my-3 border-dashed md:w-[40vw] w-full border-richblack-300 rounded-lg'>
            <div>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>
                        Section Name <sup className='text-pink-200'>*</sup>
                    </p>
                    <input
                        className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        type='text'
                        id='sectionName'
                        placeholder='Enter Section Name'
                        {...register("sectionName")}
                    />
                </label>
            </div>
            <div className='flex items-center gap-x-6'>
                <button
                    className='px-2 py-1 rounded-sm border mt-4 border-yellow-50 flex justify-center items-center gap-x-2 text-yellow-50 font-semibold hover:scale-95 transition-all duration-200'
                    type='button'
                    onClick={() => {
                        if (getValues('sectionName').trim() !== '') {
                            moduleType === 'create' ? createSectionHandler() : updateSectionNameHandler()
                        }
                    }}
                >
                    {moduleType === 'create' ? 'Create Section' : 'Update Name'}
                </button>
                {moduleType === 'update' &&
                    <button
                        className='px-2 py-1 rounded-sm border mt-4 border-yellow-50 flex justify-center items-center gap-x-2 text-yellow-50 font-semibold hover:scale-95 transition-all duration-200'
                        type='button'
                        onClick={() => setBgBlurModal(
                            <CreateLecture
                                register={register}
                                errors={errors}
                                setValue={setValue}
                                getValues={getValues}
                                setBgBlurModal={setBgBlurModal}
                                section={section}
                            />
                        )}
                    >
                        Add Lecture
                    </button>
                }
            </div>
        </div>
    );
}

export default SectionCreateOrUpdate;